export default "__VITE_ASSET__Dcmq7apb__"